import { AccountLinkModel } from 'src/Libs/installation-rights-management/models'
import { AccountLinkDto } from '../dto/account-links.dto'
import { isFlowTheme } from 'src/Libs/utils'
import { ApiPermissionType } from 'src/Libs/api/types'
import { restrictAccountLinkPermission } from '../utils'

const accountLinkToModelTransformer = (value: AccountLinkDto): AccountLinkModel => {
  // Use mapped permissions for flow-theme to ensure cross-compatibility → Can be removed after the R2-Portal is deactivated
  const generalPermissionType = (isFlowTheme ? restrictAccountLinkPermission(permissionType => value[permissionType]) : value.permissionType) || 'ro'
  const generalStoragePermissionType = (isFlowTheme ? generalPermissionType : value.storagePermissionType) || 'ro'

  return {
    id: value.id,
    installationId: value.installationId,
    accountId: value.accountId,
    accountType: value.accountType,
    accountSource: value.accountSource,
    role: value.role,
    inviteId: value.inviteId ?? '',
    startAt: value.startAt,
    stopAt: value.stopAt ?? '',
    permissionType: generalPermissionType,
    hasReadAccess: generalPermissionType === ApiPermissionType.rw || generalPermissionType === ApiPermissionType.ro,
    hasWriteAccess: generalPermissionType === ApiPermissionType.rw,
    storagePermissionType: generalStoragePermissionType,
    userName: value.userName,
    firstName: value.firstName ?? '',
    lastName: value.lastName ?? '',
    companyName: value.companyName ?? '',
    createdAt: value.createdAt,
    updatedAt: value.updatedAt,
    hasHagerEnergyApiAccess: value.hasHagerEnergyApiAccess,
  }
}

export default accountLinkToModelTransformer
